var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import moment from 'moment';
import { useEffect, useState } from 'react';
import Page from '@Components/Page';
import ResponsiveAppBar from '@Components/Header';
import Card from '@Components/Card';
import Alert from '@mui/material/Alert';
import { CardContent, CardHeader, Typography } from "@mui/material";
import { Visibility, Delete, Launch } from "@mui/icons-material";
import Button from '@Components/Button';
import Detail from './modals/Detail';
import Connect from './modals/Connect';
import { createToken, deleteToken, getTokens } from '../../services/tokens';
import Loader from '@Components/Loader';
import { useUserMetadataField } from '../../hooks/useUserMetadataField';
import ConfirmationModal from './modals/Confirmation';
export var Tokens = function () {
    var _a = useState(false), openDetail = _a[0], setOpenDetail = _a[1];
    var _b = useState(false), openConnect = _b[0], setOpenConnect = _b[1];
    var _c = useState(), confirmationType = _c[0], setConfirmationType = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var financialInstitutionId = useUserMetadataField('financialInstitutionId');
    var _e = useState([]), tokens = _e[0], setTokens = _e[1];
    var _f = useState(null), selectedToken = _f[0], setSelectedToken = _f[1];
    var _g = useState(), error = _g[0], setError = _g[1];
    var _h = useState(), creationError = _h[0], setCreationError = _h[1];
    var handleCreateToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, newToken, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    setCreationError(undefined);
                    return [4 /*yield*/, createToken()];
                case 1:
                    response = _b.sent();
                    console.log("Token created:", response);
                    newToken = {
                        id: response.data.id,
                        name: ((_a = response.data.properties) === null || _a === void 0 ? void 0 : _a.name) || "Token",
                        token: response.data.token,
                        createdAt: response.data.created_at,
                        lastUsed: response.data.expired_at
                    };
                    setTokens(__spreadArray(__spreadArray([], tokens, true), [newToken], false));
                    setConfirmationType(undefined);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _b.sent();
                    console.error("Error creating token:", error_1);
                    setCreationError(error_1.message);
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var loadTokens = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    setError(undefined);
                    return [4 /*yield*/, getTokens(financialInstitutionId)];
                case 1:
                    response = _a.sent();
                    if (response) {
                        setTokens(response);
                    }
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    console.error("Error loading tokens:", error_2);
                    setError(error_2.message);
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteToken = function (tokenId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    setError(undefined);
                    return [4 /*yield*/, deleteToken(tokenId)];
                case 1:
                    response = _a.sent();
                    console.log("Token deleted:", response);
                    setTokens(tokens.filter(function (token) { return token.id !== tokenId; }));
                    setConfirmationType(undefined);
                    return [3 /*break*/, 4];
                case 2:
                    error_3 = _a.sent();
                    console.error("Error deleting token:", error_3);
                    setError(error_3.message);
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        loadTokens();
    }, []);
    return (_jsxs(Page, { children: [_jsx(ResponsiveAppBar, {}), loading && _jsx(Loader, {}), openDetail && _jsx(Detail, { isModalOpen: openDetail, setIsModalOpen: setOpenDetail, selectedToken: tokens[0], handleCopyToken: function () { } }), openConnect && _jsx(Connect, { isModalOpen: openConnect, setIsModalOpen: setOpenConnect }), confirmationType &&
                _jsx(ConfirmationModal
                // text='¿Estás seguro de que deseas eliminar este token?'
                , { 
                    // text='¿Estás seguro de que deseas eliminar este token?'
                    text: confirmationType === 'CREATE' ? '¿Estás seguro de que deseas crear un nuevo token?' : '¿Estás seguro de que deseas eliminar este token?', 
                    // onCancel={() => setOpenConfirmation(false)}
                    onCancel: function () {
                        setConfirmationType(undefined);
                    }, onConfirm: function () {
                        if (confirmationType === 'CREATE') {
                            handleCreateToken();
                        }
                        else if (confirmationType === 'DELETE' && selectedToken) {
                            handleDeleteToken(selectedToken.id);
                        }
                        setConfirmationType(undefined);
                    }, error: error, loading: loading }), _jsxs("div", __assign({ style: { padding: '40px', width: '100%', boxSizing: 'border-box' } }, { children: [_jsx(Typography, __assign({ component: "h1", variant: "h2", sx: { width: '100%', color: '#003366' } }, { children: "Guesti\u00F3n de Tokens" })), _jsxs(Card, __assign({ sx: { marginTop: '20px' } }, { children: [_jsx(Typography, __assign({ component: "h1", variant: "h5", sx: { width: '100%', color: '#003366' } }, { children: "Generar nuevo token" })), creationError &&
                                _jsx(Alert, __assign({ severity: "error", sx: { marginBottom: '16px' } }, { children: creationError })), _jsx(Alert, __assign({ severity: "info" }, { children: "Informacion importante antes de generar." })), _jsx("div", __assign({ style: { display: 'flex', justifyContent: 'center' } }, { children: _jsx(Button, __assign({ variant: "contained", color: "primary", onClick: function () {
                                        setError(undefined);
                                        setConfirmationType('CREATE');
                                    } }, { children: "Generar token" })) }))] })), _jsxs(Card, __assign({ sx: { mx: "auto", my: '20px' } }, { children: [_jsx(CardHeader, { title: _jsx(Typography, __assign({ variant: "h5", component: "div", sx: { fontWeight: "bold", color: '#003366' } }, { children: "Tus tokens" })) }), _jsxs(CardContent, { children: [error &&
                                        _jsx(Alert, __assign({ severity: "error", sx: { marginBottom: '16px' } }, { children: error })), tokens.length === 0 && !error &&
                                        _jsx(Alert, __assign({ severity: "info", sx: { marginBottom: '16px' } }, { children: "No tienes tokens creados. Genera uno nuevo para comenzar a usar la API." })), tokens.length > 0 &&
                                        _jsx("ul", __assign({ style: { listStyle: "none", padding: 0, margin: 0 } }, { children: tokens === null || tokens === void 0 ? void 0 : tokens.map(function (token) { return (_jsx("li", __assign({ style: { borderBottom: "1px solid #e0e0e0", paddingBottom: "16px", marginBottom: "16px" } }, { children: _jsxs("div", __assign({ style: { display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", gap: "8px" } }, { children: [_jsxs("div", { children: [_jsx(Typography, __assign({ variant: "subtitle1", sx: { fontWeight: "bold", color: '#003366' } }, { children: token.name })), _jsxs(Typography, __assign({ variant: "body2", color: "text.secondary" }, { children: ["Creado: ", moment(token.createdAt).format('DD/MM/YYYY HH:mm')] }))] }), _jsxs("div", __assign({ style: { display: "flex", gap: "8px", marginTop: "8px" } }, { children: [_jsx(Button, __assign({ variant: "contained", color: "primary", startIcon: _jsx(Launch, { fontSize: "small" }), onClick: function () {
                                                                        setError(undefined);
                                                                        setSelectedToken(token);
                                                                        setOpenConnect(true);
                                                                    } }, { children: "Conectar" })), _jsx(Button, __assign({ variant: "contained", color: "primary", startIcon: _jsx(Visibility, { fontSize: "small" }), onClick: function () {
                                                                        setError(undefined);
                                                                        setSelectedToken(token);
                                                                        setOpenDetail(true);
                                                                    } }, { children: "Ver" })), _jsx(Button, __assign({ variant: "outlined", color: "error", startIcon: _jsx(Delete, { fontSize: "small" }), onClick: function () {
                                                                        setError(undefined);
                                                                        setSelectedToken(token);
                                                                        setConfirmationType('DELETE');
                                                                    } }, { children: "Remover" }))] }))] })) }), token.id)); }) }))] })] }))] }))] }));
};
